/* tslint:disable */
/* eslint-disable */
/**
 * ファイル管理ポータル クライアントAPI
 * ファイル管理ポータル Webクライアント向けAPI 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: TODO@graat.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * ファイルポータルへ遷移する際の立場が共通、共通以外、全てかを示す。 値によって参照可能なプロジェクトが変化する - owner オーナー企業を跨って共通の立場コードで参画 - exterior オーナー企業を跨って共通の立場コード以外で参画 - all 立場による参照可能プロジェクトへの制限なし 
 * @export
 * @enum {string}
 */

export const PositionTypeQuery = {
    Owner: 'owner',
    Exterior: 'exterior',
    All: 'all'
} as const;

export type PositionTypeQuery = typeof PositionTypeQuery[keyof typeof PositionTypeQuery];



